import React from 'react';
import { Badge, useTheme } from '@material-ui/core';
import { SubPageSelectButtonContainer } from './style';

interface SubPageSelectButtonProps {
    text: string;
    active?: boolean;
    notificationCount?: number;
    onClick: () => void;
}

const SubPageSelectButton = ({ text, active, notificationCount, onClick }: SubPageSelectButtonProps) => {
    const theme = useTheme();

    const containerProps = {
        backgroundColor: active ? theme.palette.success.light : undefined,
        color: active ? theme.palette.success.main : undefined,
        transitionDuration: theme.transitions.duration.shorter,
        onClick,
    };

    return (
        <Badge color="primary" overlap="circle" badgeContent={notificationCount}>
            <SubPageSelectButtonContainer {...containerProps}>
                {text}
            </SubPageSelectButtonContainer>
        </Badge>
    );
};

export default SubPageSelectButton;
